class Employer {
  constructor (data = {}) {
    this.id = data.id;
    this.customerNumber = data.customerNumber;
    this.tradeName = data.tradeName;
    this.logo = null;
    this.registrationDate = data.registrationIsoDate;
    this.terminationDate = data.terminatonIsoDate;
  }
};

export {
  Employer as default
};
